import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CharacterDetail from "../components/CharacterDetail";
import { useGlobalState } from "../context/GlobalStateContext";
import { getCharacterById } from "../services/characters";
import DiceRollerMessages from "../components/DiceRollerMessages";
import "./CharacterDetailPage.css";

function CharacterDetailPage() {
  const { id } = useParams();
  const [character, setCharacter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { updateCharacter } = useGlobalState();

  const navigate = useNavigate();

  const handleUpdateCharacter = (updatedCharacter) => {
    updateCharacter(updatedCharacter);
    setCharacter(updatedCharacter);
  };

  useEffect(() => {
    const fetchCharacter = async () => {
      try {
        setLoading(true);
        setError(null);
        const characterData = await getCharacterById(id);
        if (characterData) {
          setCharacter(characterData);
        } else {
          navigate("/characters/list");
        }
      } catch (err) {
        console.error("Error fetching character:", err);
        setError("Impossibile caricare il personaggio");
        // Dopo 2 secondi torna alla lista
        setTimeout(() => navigate("/characters/list"), 2000);
      } finally {
        setLoading(false);
      }
    };

    fetchCharacter();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className="character-detail-content">
        <div className="character-detail-loading">
          Caricamento personaggio...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="character-detail-content">
        <div className="character-detail-error">{error}</div>
      </div>
    );
  }

  return (
    <div className="character-detail-content">
      <CharacterDetail
        character={character}
        handleUpdateCharacter={handleUpdateCharacter}
      />
      <DiceRollerMessages />
    </div>
  );
}

export default CharacterDetailPage;
